import { render, staticRenderFns } from "./DataHistory.vue?vue&type=template&id=344ea182&scoped=true"
import script from "./DataHistory.vue?vue&type=script&lang=js"
export * from "./DataHistory.vue?vue&type=script&lang=js"
import style0 from "./DataHistory.vue?vue&type=style&index=0&id=344ea182&prod&lang=scss"
import style1 from "./DataHistory.vue?vue&type=style&index=1&id=344ea182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344ea182",
  null
  
)

export default component.exports